import { IScrollStats } from '../model/IScrollStats';

export function checkIsScrollable(stats: IScrollStats | null) {
    if (!stats) {
        return false;
    }
    const { clientWidth, scrollWidth } = stats;
    return scrollWidth > clientWidth;
}
